<template>
  <div class="post">
    <c-table ref="table" :columns="columns" url="/publish">
      <template #operate>
        <el-button type="primary" @click="visible = true">上传文件</el-button>
      </template>
      <el-table-column slot="caozuo" label="操作" width="180" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" @click="detail(row.publish_id)">查看</el-button>
          <el-button type="text" @click="upload(row)" :loading="row.loading">重新上传</el-button>
          <el-button type="text" @click="remove(row, $event)">删除</el-button>
        </template>
      </el-table-column>
    </c-table>
    <el-upload
      style="display:none;"
      ref="upload"
      :show-file-list="false"
      action="/api/publish/change2"
      :data="{publish_id: currentPost.publish_id}"
      :before-upload="() => $set(currentPost, 'loading', true)"
      :on-success="onSuccess"
    ></el-upload>
    <upload v-model="visible"></upload>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import Upload from './#upload'
import mixin from '@/mixins'

export default {
  name: 'staff-dimission',
  mixins: [ mixin ],
  components: { CTable, Upload },
  data () {
    return {
      visible: false,
      columns: [
        { prop: 'publish_name', label: '文件名' },
        { prop: 'publish_time', label: '上传时间', width: 180 },
        { prop: 'username', label: '上传者', width: 110 },
        { slot: 'caozuo' }
      ],
      currentPost: {}
    }
  },
  methods: {
    onSuccess () {
      this.currentPost.loading = false
      this.$notify.success({ title: '成功', message: '操作成功' })
    },
    upload (post) {
      this.currentPost = post
      this.$refs.upload.$refs[ 'upload-inner' ].$refs.input.click()
    },
    detail (id) {
      window.open(`/api/publish/get?publish_id=${id}`)
    },
    remove (row, event) {
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.publish_name,
        operate: () =>
          this.$http.post(`/publish/delete2`, {
            publish_id: row.publish_id
          }),
        callback: () => {
          this.$refs.table.reload()
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>
